export const navLinks = [
    {
      id: 1,
      title: 'Home',
      link: '/'
    },
    {
      id: 2,
      title: 'Dukaan',
      link: '/products'
    },
    {
      id: 3,
      title: 'Kahani',
      link: '/about'
    },
    {
      id: 4,
      title: 'Baat Cheet',
      link: '/contact'
    },
    {
      id: 5,
      title: 'Humko join karlo!',
      link: '/become-partner'
    }
  ];
  